import http from "@/http"
import { createFormSubmissionObj } from "@/libs/common"

let modulePath = "personal/Application";

const post = function(path, data, config = {}) {
  return http.post(`${modulePath}/${path}`, data, config);
}

export default  {
  getExpiryDate(jwt, cardNum) {
    return http.get(`${modulePath}/getExpiryDate`, {
      headers: {
        Authorization: "Bearer " + jwt,
      },
      params: {
        cardNum: cardNum
      }
    });
  },
  getDisplayInfoForRenew(jwt) {
    return http.get(`${modulePath}/getDisplayInfoForRenew`, {
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
  },
  postFormValidate(jwt, dataObj) {
    let obj = createFormSubmissionObj(dataObj);
    obj.photo = null;
    return post("validation", obj, {
      headers: {
        Authorization: "Bearer " + jwt,
        "Content-Type": "application/json"
      }
    })
  },
  postSubmitForm(jwt, dataObj) {
    return post("submit", createFormSubmissionObj(dataObj), {
      headers: {
        Authorization: "Bearer " + jwt,
        "Content-Type": "application/json"
      }
    })
  },
  postSendSubmissionEmail(jwt, formId) {
    return post("sendSubmissionEmail", null, {
      headers: {
        Authorization: "Bearer " + jwt,
        "Content-Type": "application/json"
      },
      params: {
        formId: formId,
        isResend: false
      }
    })
  },
  postFormFileValidate(jwt, formData) {
    return post("validationFile", formData, {
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "multipart/form-data"
      }
    })
  },
  postUploadFile(jwt, formData) {
    return post("upload", formData, {
      headers: {
        Authorization: `Bearer ${jwt}`,
        "Content-Type": "multipart/form-data"
      }
    })
  },
  getUploadFilesResult(jwt) {
    return http.get(`${modulePath}/isAllAttachmentReady`, {
      headers: {
        Authorization: `Bearer ${jwt}`
      }
    });
  }
}